import type { ICrmFieldsFilterDto } from "app/pages/sales-intelligence/domain/crm-integration/types/filter-options";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type { ICrmFilterOptions } from "../../types/options.dto";

export default class CrmFieldsFilter extends FilterPanelBaseFilter<ICrmFieldsFilterDto, ICrmFilterOptions> {
    isValueEmpty(value?: ICrmFieldsFilterDto): boolean {
        return !value?.listFieldsFilters?.some((c) => !is.undefined(c.fieldValues));
    }
}
